import * as http from './base-api'
import * as querystring from 'querystring'


/**
 * 공지 등록
 *
 * @param data
 * @returns {*}
 */
export const createNotice = (data) => {
    return http.post('/cms/notice', data)
}

/**
 * 공지 검색
 *
 * @param params
 * @returns {*}
 */

export const retrieveNotice = (params) => {
    return http.get(`/cms/notice?${querystring.stringify(params)}`)
    // return http.demoGet(`/contents_01.json?${querystring.stringify(params)}`)
}

/**
 * 공지 상세 검색
 *
 * @param params
 * @returns {*}
 */

export const findNotice = (id) => {
    return http.get(`/cms/notice/${id}`)
}

/**
 * 공지 정보 삭제
 *
 * @param product_id
 */
export const removeNotice = (id) => {
    return http.remove(`/cms/notice/${id}`)
}

/**
 * 공지 정보 수정
 *
 * @param data
 * @param id
 * @returns {*}
 */
export const modifyNotice = (data, id) => {
    return http.put(`/cms/notice/${id}`, data)
}
